import {Component, store} from 'Generic';
import {removeCouponCode, isTrialPlan, isFpdrPlan} from 'Generic/lib';

export default class CheckoutForm extends Component {
  constructor() {
    super({
      store,
      state: store.state,
    });
  }

  render() {
    let cartState = this.state ? this.state : {};
    let selectedPlan = cartState.selected_plan ? cartState.selected_plan : {};
    let selectedGateway = cartState.selected_gateway;
    let payButtonTitle = document.querySelector('#submit_btn_title');

    switch (selectedGateway) {
      case 'stripe':
        this.showHideCardFields(true);
        break;
      default:
        this.showHideCardFields(false);
    }

    this.showApplyCouponOption(selectedPlan);

    payButtonTitle.innerHTML = cartState.selected_gateway_name;
  }

  showHideCardFields(show) {
    let cardHolderNameField = document.querySelector('.card-holder');
    let paymentBoxField = document.querySelector('.payment_box');

    if (show) {
      cardHolderNameField.style.display = 'block';
      paymentBoxField.style.display = 'block';
      return;
    }

    cardHolderNameField.style.display = 'none';
    paymentBoxField.style.display = 'none';
  }

  showApplyCouponOption(selectedPlan) {
    let {labels = {}} = selectedPlan;

    let showApplyCoupon = labels.show_apply_coupon ? labels.show_apply_coupon : 0;

    if (isTrialPlan() || cartState.gateway_incentive_promo_code) {
      showApplyCoupon = 0;
    }

    this.toggleApplyCouponBoxHideShow(Number(showApplyCoupon));
  }

  toggleApplyCouponBoxHideShow(show) {
    let applycouponbox = document.querySelector('#desktop-coupon-box');
    let popupform = document.querySelector('#popupform');
    let display = 'block';

    document.querySelector('#coupon-toggle').style.display = 'block';

    if (!show && popupform) {
      document.querySelector('#coupon-toggle').style.display = 'none'; //hide frontend coupon toggle
      document.querySelector('.payment-coupon-box').classList.remove('active'); //hide frontend coupon box
    }
    if (!show) {
      removeCouponCode();
      display = 'none';
    }

    applycouponbox.style.display = display;
  }
}
